/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiCloneExistingCredentialsRequest,
  ErrorResponse,
  ProcessAuthorizationCode3Params,
  UrlResponse,
  UserAlreadyConnectedResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiGoogleAdsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-google-ads-controller
   * @name CloneExistingCredentials2
   * @request POST:/api/v1/document-fetcher/google-ads/clone
   */
  cloneExistingCredentials = (
    data: ApiCloneExistingCredentialsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/document-fetcher/google-ads/clone`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static cloneExistingCredentialsPath = '/v1/document-fetcher/google-ads/clone'
  static cloneExistingCredentialsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-google-ads-controller
   * @name ProcessAuthorizationCode3
   * @summary Gets OAuth2 code and tries to establish an integration
   * @request GET:/api/v1/document-fetcher/google-ads/oauth2code
   */
  processAuthorizationCode = (query: ProcessAuthorizationCode3Params, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/v1/document-fetcher/google-ads/oauth2code`,
      method: 'GET',
      query: query,
      ...params,
    })

  static processAuthorizationCodePath = '/v1/document-fetcher/google-ads/oauth2code'
  static processAuthorizationCodeMethod = 'GET'
  /**
   * No description
   *
   * @tags api-google-ads-controller
   * @name GetAuthorizationCodeRequestUrl3
   * @summary Gets URL to redirect a user to in order to start OAuth consent flow
   * @request GET:/api/v1/document-fetcher/google-ads/authorizationCodeRequestUrl
   */
  getAuthorizationCodeRequestUrl = (params: RequestParams = {}) =>
    this.http.request<UrlResponse | UserAlreadyConnectedResponse, ErrorResponse>({
      path: `/v1/document-fetcher/google-ads/authorizationCodeRequestUrl`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAuthorizationCodeRequestUrlPath =
    '/v1/document-fetcher/google-ads/authorizationCodeRequestUrl'
  static getAuthorizationCodeRequestUrlMethod = 'GET'
}
